"use client"

import { BrandType } from "@/app/types/brand";
import { Link as MuiLink } from "@mui/material";
import MediaV2 from "@v2/components/MediaV2";
import Link from "next/link";

export default function PdpBrandImage({ brand }: {
    brand: BrandType
}) {
    if (!brand) return <></>

    return (
        <MuiLink component={Link} aria-label={`show brand ${brand.en_name}`} href={`/fa/brand/${brand.slug}`} target="_blank" sx={{
            display: 'inline-block'
        }}>
            <MediaV2
                media_id={brand.logo?.id}
                alt={brand.logo?.alt ?? `${brand.fa_name} - ${brand.en_name}`}
                disablePlaceholder
                height={130} imageProps={{
                    fill: true,
                    loading: 'eager',
                    priority: true,
                    style: {
                        objectFit: 'contain'
                    }
                }} boxProps={{
                    sx: {
                        height: 56,
                        aspectRatio: '2 / 1',
                        borderRadius: 1,
                        '&:hover': {
                            boxShadow: '0 1px 3px rgba(0,0,0,0.15)'
                        }
                    }
                }} />
        </MuiLink>
    )
}